export { default as TemplateHeader } from '@/views/templates/components/TemplateHeader.vue';
export { default as TemplateNavigation } from '@/views/templates/components/TemplateNavigation.vue';
export { default as TemplateProfile } from '@/views/templates/components/TemplateProfile.vue';
export { default as TemplateSidebar } from '@/views/templates/components/TemplateSidebar.vue';
